import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Outlet, useNavigate, useLocation, useParams } from "react-router-dom";
import TopNavbar from "../../Components/TopNavbar/TopNavbar";
import UserDetail from "../../Pages/NewUserPages/UserDetail";
// import PreOnboardingStatus from "../../Pages/NewUserPages/PreOnboardingStatus";


import { Button, Steps, theme, notification } from "antd";
import { GetDropDownApi } from "../../Services/CommonApis";
import { arrayToOptions } from "../../Services/GeneralFunctions";
import axios from "axios";
import { getEmployeeDetailApi } from "../../Services/EmployeeOnboarding";
import { PageLoader } from "../../Services/PageLoader";
import { Loader } from "../../Services/Loader";
import "../../Components/FormComponents/Form.css";

export default function NewUser() {
  const [api, contextHolder] = notification.useNotification();
  const [responseData, setResponseData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dropDowns, setDropDowns] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [currentStep, setCurrentStep] = useState("personal");
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);

  const type = localStorage.getItem("userType");

  const [maxCompletedStep, setMaxCompletedStep] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const pathSegment = location.pathname.split("/").pop();

  const stepRoutes = [
    "personal",
    "identity-detail",
    "bank-details",
    "documents",
    "nominees",
    "offer-letter",
  ];


  const stepKeys = [
    "personal_details",
    "contact_details",
    "address_details",
    "education_details",
    "know_my_team",
  ];

  const identityRelatedKeys = [
    "id_cards",
    "employment_history",
    "reference_details",
    "esic_details",
    "pf_details",
  ];

  const sectionToRouteMap = {
    personal_details: "personal",
    contact_details: "identity-detail",
    address_details: "bank-details",
    education_details: "documents",
    know_my_team: "nominees",
  };

  const { id } = useParams();
  const handleNavigate = (url) => {
    navigate(
      `/${type === "admin" ? `admin/employees-view/${id}` : "new-user"}/${url}`,
    );
  };
  const getStepper = async () => {
    try {
      let data = {};

      if (type !== "admin") {
        data = await axios.get("/api/employees/section-completion");
      }

      const completion = data?.data?.progress_bar_status || {};

      const hasBankDetails = completion["bank_details"];
      const hasDoc = completion["documents"];
      console.log(hasDoc, "checking doc");
      const hasNominee = completion["nominees"];
      let Appointment = false;

      const currentRoute = location.pathname.split("/").pop();

      const stepsOrder = [
        "personal",
        "identity-detail",
        "bank-details",
        "documents",
        "nominees",
        "offer-letter",
      ];


      let maxStepIndex = 0;
      if (hasNominee) {
        maxStepIndex = stepsOrder.indexOf("offer-letter");
        Appointment = true;
      } else if (hasDoc) {
        maxStepIndex = stepsOrder.indexOf("documents");
      } else if (hasBankDetails) {
        maxStepIndex = stepsOrder.indexOf("bank-details");
      } else {
        for (let i = 0; i < stepsOrder?.length; i++) {
          const stepKey = stepsOrder[i];
          if (!completion?.[stepKey]) {
            maxStepIndex = i - 1;
            break;
          }
          maxStepIndex = i;
          if (stepKey === "bank-details") break;
        }
        if (maxStepIndex < 0) maxStepIndex = 0;
      }

      setMaxCompletedStep(maxStepIndex);

      if (isInitialLoad) {
        setIsInitialLoad(false);

        if (Appointment) {
          setCurrentStep("offer-letter");
          if (currentRoute !== "offer-letter") {
            handleNavigate("offer-letter");
            // navigate(`/new-user/`);
          }
          return;
        }

        if (hasNominee) {
          setCurrentStep("nominees");
          if (currentRoute !== "nominees") {
            handleNavigate("nominees");
            // navigate(`/new-user/`);
          }
          return;
        }

        if (hasDoc) {
          console.log(hasDoc, "checking hasDoc");
          setCurrentStep("nominees");
          if (currentRoute !== "nominees") {
            handleNavigate("nominees");
            // navigate(`/new-user/documents`);
          }
          return;
        }

        if (hasBankDetails) {
          setCurrentStep("documents");
          if (currentRoute !== "documents") {
            handleNavigate("documents");
            // navigate(`/new-user/bank-details`);
          }
          return;
        }

        const hasIdentityData = identityRelatedKeys.every(
          (key) => completion[key],
        );
        console.log(
          hasIdentityData,
          identityRelatedKeys,
          completion,
          "checking hasIdentityData-----------",
        );

        if (hasIdentityData) {
          setCurrentStep("bank-details");
          if (currentRoute !== "bank-details") {
            handleNavigate("bank-details");
            // navigate(`/new-user/identity-detail`);
          }
          return;
        }

        const incompleteStepKey = stepKeys.find((key) => !completion[key]);
        const nextStep = incompleteStepKey
          ? sectionToRouteMap[incompleteStepKey]
          : "identity-detail";

        setCurrentStep(nextStep);
        if (currentRoute !== nextStep) {
          handleNavigate(nextStep);
          // navigate(`/new-user/${nextStep}`);
        }
      } else {
        if (stepRoutes.includes(currentRoute)) {
          setCurrentStep(currentRoute);
        }
      }
    } catch (error) {
      setCurrentStep("personal");
      setMaxCompletedStep(0);
    }
  };

  const fetchEmployeeDetail = async (id1) => {
    setIsLoadingData(true);
    let data = {};
    const type = localStorage.getItem("userType");

    if (type) {
      try {
        setIsLoading(true);

        data = await getEmployeeDetailApi();

        if (!data?.data?.success) {
          // api.success({
          //   message: data?.data?.message,
          //   placement: "top",
          // });
          // return;
        }

        setResponseData(data?.data?.data);
      } catch (error) {
        api.error({
          message: error.message || "Network error",
          placement: "top",
        });
      } finally {
        setIsLoading(false);
        setIsLoadingData(false);
      }
    }
  };

  const getAllDropDowns = async () => {
    try {
      const data = await GetDropDownApi("");
      if (data.data.success) {
        const optionsArray = {};
        data.data.data.forEach((val) => {
          if (val?.field) {
            optionsArray[val.field.toUpperCase()] = arrayToOptions(val?.value);
          }
        });
        setDropDowns(optionsArray);
      } else {
        api.error({
          message: "Error while fetching dropdowns",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection",
        placement: "top",
      });
    }
  };

  const getProfileData = async () => {
    setIsPageLoading(true);
    let data = {};
    const type = localStorage.getItem("userType");

    if (type) {
      try {
        setIsLoading(true);

        data = await getEmployeeDetailApi();

        if (!data?.data?.success) {
          // api.success({
          //   message: data?.data?.message,
          //   placement: "top",
          // });
          // return;
        }

        setResponseData(data?.data?.data);
      } catch (error) {
        api.error({
          message: error.message || "Network error",
          placement: "top",
        });
      } finally {
        setIsLoading(false);
        setIsPageLoading(false);
      }
    }
  };

  const init = async (id, type) => {
    // await fetchEmployeeDetail(id);
    await getStepper();
    await getAllDropDowns();
    await getProfileData();
  };

  useEffect(() => {
    init(id, type);
  }, [id, location.pathname]); // Re-fetch data on every route change

  // When user navigates manually or clicks tabs, update currentStep accordingly:
  useEffect(() => {
    if (!isInitialLoad && stepRoutes.includes(pathSegment)) {
      setCurrentStep(pathSegment);
    }
  }, [pathSegment, isInitialLoad]);

  const steps = [
    { title: "Personal Details" },
    { title: "Employment & Identity" },
    { title: "Bank Details" },
    { title: "Documents" },
    { title: "Nominee & Declarations" },
    { title: "Appointment Letter" },
  ];


  const { token } = theme.useToken();
  const current =
    stepRoutes.indexOf(currentStep) !== -1
      ? stepRoutes.indexOf(currentStep)
      : 0;

  const onStepClick = (stepIndex) => {
    handleNavigate(stepRoutes[stepIndex]);
    // navigate(`/new-user/${stepRoutes[stepIndex]}`);
    getAllDropDowns();
    fetchEmployeeDetail();
  };

  const items = steps.map((item, index) => {
    const isCurrent = index === current;

    const isActive = index <= current;
    const isEnabled = index <= maxCompletedStep;
    const isTailActive = index < maxCompletedStep;
    const currentInableActive = isActive || isEnabled;

    return {
      key: item.title,
      title: (
        <div
          className={`text-xs m-0 text-center   ${currentInableActive
            ? "font-bold text-primary"
            : "font-normal text-gray-500"
            }`}
        >
          {item.title}
        </div>
      ),
      icon: (
        <div
          style={{ border: isCurrent && "1px solid #009bde" }}
          className={`
      inline-flex items-center justify-center rounded-full 
      ${isCurrent ? " scale-110 shadow-2xl " : ""}
    `}
        >
          <div
            className={`w-5 h-5 m-[1px] rounded-full flex items-center justify-center   
           
           font-semibold ${currentInableActive ? "text-white" : "text-gray-500"
              }`}
            style={{
              fontSize: "10px",
              lineHeight: 1,
              border: currentInableActive
                ? "none"
                : `1.5px solid ${token.colorBorderSecondary}`,
              backgroundColor: currentInableActive ? "#009bde" : "transparent",
              display: "inline-flex",
              verticalAlign: "middle",
            }}
          >
            {index + 1}
          </div>
        </div>
      ),
      className: isTailActive ? "step-tail-primary" : "", // 👈 apply a class to control tail
      disabled: (type !== "admin" && !responseData?.final_submit && !responseData?.flagged_fields?.length) ? !currentInableActive : false,
    };
  });

  return (
    <>
      {contextHolder}
      <Helmet>
        <style>{`body { background: #F9FAFB; }`}</style>
      </Helmet>
      <PageLoader loading={isPageLoading} />

      <div id="dashboard-body">
        <TopNavbar />

        {/* Check if user should see the Status Dashboard instead of the Stepper Flow
        {responseData && (responseData.is_submitted || responseData.onboarding_status === 'submitted' || responseData.onboarding_status === 'rejected' || responseData.onboarding_status === 'under_review' || responseData.onboarding_status === 'offer_generated' || responseData.onboarding_status === 'offer_accepted') ? (
          <PreOnboardingStatus 
            responseData={responseData} 
            onStatusChange={(newStatus) => {
              // This is for demo/testing purposes
              console.log("Status changed to:", newStatus);
            }} 
          />
        ) : ( */}
        <div className="mt-3 mx-auto px-2 sm:px-0 max-w-[82rem]">
          {responseData && <UserDetail responseData={responseData} />}

          {responseData && (
            <section className="p-6 w-full h-full mt-3 px-12">
              <Steps
                labelPlacement="vertical"
                className="custom-steps responsive-hidden overflow-x-auto md:overflow-hidden"
                style={{ maxHeight: "170px", cursor: "pointer" }}
                current={current}
                responsive={false}
                items={items}
                onChange={onStepClick}
              />
            </section>
          )}
          <div
            className="py-3 my-3"
            style={{
              height: "calc(100% - 76px)",
              overflow: "auto",
              paddingBottom: "80px",
            }}
          >
            {(isLoadingData && <Loader loading={true} />) || (
              <>
                {responseData && (
                  <Outlet
                    context={{
                      responseData,
                      dropDowns,
                      profileData,
                      isLoading,
                      id,
                    }}
                  />
                )}
              </>
            )}
          </div>
        </div>
        {/* )} */}
      </div>

    </>
  );
}
